<template>
  <div>
    <div v-if="loading">正在处理授权回调...</div>
    <div v-else-if="errorMessage">{{ errorMessage }}</div>
    <div v-else>授权成功！正在跳转至主页...</div>
  </div>
</template>

<script>
import { getAuthUrlByDingTalk} from '@/api/api'

export default {
  data() {
    return {
      loading: true,
      errorMessage: ''
    };
  },
  mounted() {
    this.handleDingTalkCallback();
  },
  methods: {
    async handleDingTalkCallback() {
      try {
        // 获取钉钉授权URL的方法
        getAuthUrlByDingTalk().then(response => {
              const authUrl = response.data; 
              window.location.href = authUrl;
          })
          .catch(error => {
              this.$message.error('获取钉钉授权URL失败，请稍后重试');
              this.$router.push({ path: '/login' })
              console.error(error);
          });     
       
        
      } catch (error) {
        this.loading = false;
        this.errorMessage = `授权回调处理失败：${error.message}`;
        console.error(error);
      }
    },
  },
};
</script>

<style scoped>
/* 可以根据需要添加样式 */
</style>    


// WEBPACK FOOTER //
// src/views/dingTalkAutoLogin.vue